import { render, staticRenderFns } from "./PkBatchRouteUpdate.vue?vue&type=template&id=75f2a281&"
import script from "./PkBatchRouteUpdate.vue?vue&type=script&lang=js&"
export * from "./PkBatchRouteUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports